import { render, staticRenderFns } from "./BoxFive.vue?vue&type=template&id=5e6d5395&scoped=true"
import script from "./BoxFive.vue?vue&type=script&lang=js"
export * from "./BoxFive.vue?vue&type=script&lang=js"
import style0 from "./BoxFive.vue?vue&type=style&index=0&id=5e6d5395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6d5395",
  null
  
)

export default component.exports